// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import router from './router'; // 导入路由配置
import { createI18n } from 'vue-i18n'
import en from './locales/en'
import zh from './locales/zh'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || 'zh', // 默认语言
  messages: { en, zh },
})
const app = createApp(App);
app.use(router); // 注册路由
app.use(ElementPlus);
app.use(i18n);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
export const switchLanguage = (lang) => {
  i18n.global.locale.value = lang
  localStorage.setItem('lang', lang) // 持久化存储
}
app.mount('#app');